import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Layout, Image } from 'antd';
import { DownloadOutlined, CodeOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import UserMenu from './UserMenu';
import LanguageSwitcher from './LanguageSwitcher';
import styles from './HeaderCom.module.css';

const { Header } = Layout;

const HeaderCom: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation('components');

  const navItems = [
    {
      key: '/downloads',
      icon: <DownloadOutlined />,
      label: t('header.downloads'),
      ariaLabel: t('header.downloadsAriaLabel'),
      to: '/downloads',
      external: false,
    },
    {
      key: 'playground',
      icon: <CodeOutlined />,
      label: 'Playground',
      ariaLabel: 'Playground',
      to: 'https://play.enrigin.com.cn',
      external: true,
    },
    {
      key: 'ticket',
      icon: <QuestionCircleOutlined />,
      label: t('header.tickets'),
      ariaLabel: t('header.ticketsAriaLabel'),
      to: 'https://ticket.enrigin.com.cn',
      external: true,
    },
  ];

  return (
    <Header className={styles.header}>
      <div className={styles.logoSection}>
        <a
          href="https://www.enrigin.com.cn/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.logoLink}
        >
          <Image
            src="/logo.png"
            alt="Logo"
            preview={false}
            style={{ height: '40px' }}
            fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg=="
            data-testid="header-logo"
          />
        </a>
      </div>

      <div className={styles.rightSection}>
        <nav className={styles.desktopMenu}>
          {navItems.map((item) =>
            item.external ? (
              <a
                key={item.key}
                href={item.to}
                target="_blank"
                rel="noopener noreferrer"
                className={`${styles.navItem} ${location.pathname === item.key ? styles.navItemSelected : ''}`}
                data-testid={`menu-${item.key}`}
                aria-label={item.ariaLabel}
              >
                {item.icon}
                <span>{item.label}</span>
              </a>
            ) : (
              <Link
                key={item.key}
                to={item.to}
                className={`${styles.navItem} ${location.pathname === item.key ? styles.navItemSelected : ''}`}
                data-testid={`menu-${item.key}`}
                aria-label={item.ariaLabel}
              >
                {item.icon}
                <span>{item.label}</span>
              </Link>
            )
          )}
        </nav>
        <LanguageSwitcher />
        <div className={styles.userMenu} data-testid="user-menu">
          <UserMenu />
        </div>
      </div>
    </Header>
  );
};

export default HeaderCom;
